<template>
    <div>
        <div class="loader" v-show="showLoading"></div>
        <div v-show="!showLoading">
            <div class="grid-wrapper">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :filter="filter"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size="gridOptions.pageable.size"
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd"></kendo-datasource>
                <kendo-grid ref="participantsGrid"
                            :data-source-ref="'datasource1'"
                            ::navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :resizable="gridOptions.resizable"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :scrollable="gridOptions.scrollable"
                            :data-bound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :filterable="false"
                                       :title="$t('registers.events.participants.gridHeaders.eventId')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventName'"
                                       :title="$t('registers.events.participants.gridHeaders.eventName')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column v-if="showBtns"
                                       :filterable="false"
                                       field="btnsColumn"
                                       :title="$t('registers.events.participants.gridHeaders.management')"
                                       :sortable="false"
                                       :template="btnsTemplate"
                                       :width="150"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLocation'"
                                       :title="$t('registers.events.gridHeaders.eventLocation')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('registers.events.gridHeaders.eventStartDate')"
                                       :width="200"
                                       :format="'{0: dd.MM.yyyy}'"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('registers.events.gridHeaders.eventEndDate')"
                                       :width="200"
                                       :format="'{0: dd.MM.yyyy}'"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'thematicArea'"
                                       :title="$t('registers.events.gridHeaders.thematicArea')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'theme'"
                                       :title="$t('registers.events.gridHeaders.theme')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationType'"
                                       :title="$t('registers.events.participants.gridHeaders.participationType')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationTypeEn'"
                                       :title="$t('registers.events.participants.gridHeaders.participationType')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'syncWithMoodle'"
                                       :title="$t('registers.events.participants.gridHeaders.syncWithMoodle')"
                                       :width="150"
                                       :template="syncedCellTemplate"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isFromTempRanking'"
                                       :title="$t('registers.events.participants.gridHeaders.isFromTempRanking')"
                                       :width="200"
                                       :template="tempRankCellTemplate"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'fullName'" :title="$t('registers.events.participants.gridHeaders.name')"
                                       :width="300" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'relationTypeName'"
                                       :title="$t('registers.events.participants.gridHeaders.relationType')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'relationTypeNameEn'"
                                       :title="$t('registers.events.participants.gridHeaders.relationType')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdAt'"
                                       :title="$t('registers.events.participants.gridHeaders.createdAt')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedAt'"
                                       :title="$t('registers.events.participants.gridHeaders.updatedAt')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
        <DetailsModal v-model="detailsModel" :show="showDetails" @onClose="onDetailsClose"></DetailsModal>
    </div>
</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import BtnsTemplate from "../../../components/grid/StandardBtnsTemplate";
    import {Culture, RegisterFieldValueQueryFilter} from '../../../models/enums';
    import DetailsModal from '../../../components/dynamic/register/details.modal';

    export default {
        name: 'lecturer-participants-grid',
        components: {
            DetailsModal
        },
        props: {
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            componentName: {
                default: 'ParticipantsListGrid',
                type: String
            },
            lecturerId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                titleKey: 'registers.events.participants.title',
                searchQuery: '',
                showLoading: false,
                schemaModelFields: {
                    id: {name: 'id', type: 'number', editable: false, nullable: false, visible: true},
                    registerEntityId: {
                        name: 'registerEntityId',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    registerFieldId: {
                        name: 'registerFieldId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    personId: {name: 'personId', type: 'number', editable: false, nullable: false, visible: true},
                    eventName: {name: 'eventName', type: 'string', editable: false, nullable: true, visible: true},
                    eventLocation: {
                        name: 'eventLocation',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    relationTypeId: {
                        name: 'relationTypeId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    thematicArea: {
                        name: 'thematicArea',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    theme: {
                        name: 'thematicArea',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    participationType: {
                        name: 'participationType',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    participationTypeEn: {
                        name: 'participationTypeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    relationTypeName: {
                        name: 'relationTypeName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    relationTypeNameEn: {
                        name: 'relationTypeNameEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    isRelationTypeForParticipation: {
                        name: 'isRelationTypeForParticipation',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    relationTypeCode: {
                        name: 'relationTypeCode',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    eventPersonTypeId: {
                        name: 'eventPersonTypeId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    registerEntityParticipantMigrationId: {
                        name: 'registerEntityParticipantMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    createdBy: {name: 'createdBy', type: 'string', editable: false, nullable: true, visible: true},
                    createdAt: {name: 'createdAt', type: 'date', editable: false, nullable: true, visible: true},
                    updatedBy: {name: 'updatedBy', type: 'string', editable: false, nullable: true, visible: true},
                    updatedAt: {name: 'updatedAt', type: 'date', editable: false, nullable: true, visible: true},
                    eventStartDate: {
                        name: 'eventStartDate',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    eventEndDate: {name: 'eventEndDate', type: 'date', editable: false, nullable: true, visible: true},
                    migrationData: {
                        name: 'migrationDataS',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    rejected: {name: 'rejected', type: 'boolean', editable: false, nullable: false, visible: true},
                    deleted: {name: 'deleted', type: 'boolean', editable: false, nullable: false, visible: true},
                    firstName: {name: 'firstName', type: 'string', editable: false, nullable: true, visible: true},
                    middleName: {name: 'middleName', type: 'string', editable: false, nullable: true, visible: true},
                    lastName: {name: 'lastName', type: 'string', editable: false, nullable: true, visible: true},
                    fullName: {name: 'fullName', type: 'string', editable: false, nullable: true, visible: true},
                    identificationType: {
                        name: 'identificationType',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    identificationNumber: {
                        name: 'identificationNumber',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    phone: {name: 'phone', type: 'string', editable: false, nullable: true, visible: true},
                    mobilePhone: {name: 'mobilePhone', type: 'string', editable: false, nullable: true, visible: true},
                    email: {name: 'email', type: 'string', editable: false, nullable: true, visible: true},
                    position: {name: 'position', type: 'string', editable: false, nullable: true, visible: true},
                    positionEn: {name: 'positionEn', type: 'string', editable: false, nullable: true, visible: true},
                    description: {name: 'description', type: 'string', editable: false, nullable: true, visible: true},
                    gender: {name: 'gender', type: 'string', editable: false, nullable: true, visible: true},
                    genderEn: {name: 'genderEn', type: 'string', editable: false, nullable: true, visible: true},
                    hasParent: {name: 'hasParent', type: 'boolean', editable: false, nullable: true, visible: true},
                    parentFirstName: {
                        name: 'parentFirstName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    parentMiddleName: {
                        name: 'parentMiddleName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    parentLastName: {
                        name: 'parentLastName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    parentFullName: {
                        name: 'parentFullName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    username: {name: 'username', type: 'string', editable: false, nullable: true, visible: true},
                    participantMigrationId: {
                        name: 'participantMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    lecturerMigrationId: {
                        name: 'lecturerMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    organizerMigrationId: {
                        name: 'organizerMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    educationDegree: {
                        name: 'educationDegree',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    educationDegreeEn: {
                        name: 'educationDegreeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    titleDegree: {name: 'titleDegree', type: 'string', editable: false, nullable: true, visible: true},
                    titleDegreeEn: {
                        name: 'titleDegreeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionNomenclature: {
                        name: 'institutionNomenclature',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionNomenclatureEn: {
                        name: 'institutionNomenclatureEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionRegister: {
                        name: 'institutionRegister',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionRegisterLocation: {
                        name: 'institutionRegisterLocation',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    hasChanges: {name: 'hasChanges', type: 'boolean', editable: false, nullable: true, visible: true},
                    syncWithMoodle: {
                        name: 'syncWithMoodle',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    syncMoodleResult: {
                        name: 'syncMoodleResult',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    isFromTempRanking: {
                        name: 'isFromTempRanking',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                },
                formToEventFields: {
                    id: {name: 'id', from: 'id', type: 'number', nullable: false},
                    name: {name: 'name', from: 'name', type: 'string', nullable: false},
                    nameEn: {name: 'name', from: 'name', type: 'string', nullable: true},
                    type: {name: 'name', from: 'name', type: 'string', nullable: true},
                    typeEn: {name: 'name', from: 'name', type: 'string', nullable: true}
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel', 'pdf'],
                    excel: {
                        fileName: 'Participants.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: 'Participants.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: {top: '2cm', left: '1cm', right: '1cm', bottom: '1cm'},
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                },
                working: false,
                showUserSettingsForm: false,
                showPersonEdit: false,
                personModel: null,
                showPersonDetails: false,
                participantModel: null,
                showParticipanrEdit: false,
                detailsModel: null,
                showDetails: false,
            }
        },
        methods: {
            dataBound(ev) {
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return {models: kendo.stringify(options.models)}
                } else {
                    // ������ POST action �� �������� �� �������������� � ������ �� �������������
                    // options. ���� �� ������� ���������� �� take, skip , page � ������ � ������
                    // �������� �����������
                    return kendo.stringify(options);
                }
            },
            detailsAllBtnClick(args) {
                this.showDetailsModal(args, RegisterFieldValueQueryFilter.All);
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            resize(componentName, size) {
                this.$emit('resize', componentName, size, this.$refs.participantsGrid.kendoWidget())
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            hide(componentName) {
                this.$emit('hide', componentName)
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            pinned(componentName) {
                this.$emit('pinned', componentName)
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            unpinned(componentName) {
                this.$emit('unpinned', componentName)
            },
            datasorceRequestEnd(e) {
                if (e.type == "read" && e.response) {
                    // 	console.log(e.response[0]);
                    //alert(e.respondashboard-ctrlse[0].TaskID);
                }
            },
            deactivatedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deactivated ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isTemplateCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isTemplate ? 'badge-success' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isTemplate ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            statusCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.status.indexOf('Active') >= 0 ? 'badge-success' : (dataItem.status.indexOf('Passed') >= 0 ? 'badge-warning' : 'badge-info')) + '">' + kendo.htmlEncode(dataItem.status) + '</span>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        btns: this.gridBtns
                    }
                }
            },
            eventDetailsBtnClick(args) {
                if (!this.$store.getters.claims.event.read) {
                    return this.$router.push(`/unauthorized`);
                }

                this.detailsAllBtnClick(args);
            },
            showDetailsModal(args, filter) {
                this.$api.dynamicRegister
                    .getDetails(args.registerEntityId, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.detailsModel = model;
                            this.showDetails = true;
                        }
                    })
                    .catch(error => {
                        this.detailsModel = null;
                        this.showDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onDetailsClose() {
                this.showDetails = false;
                this.detailsModel = null;
            },
            refresh() {
                const grid = this.$refs.participantsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            syncedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.syncWithMoodle ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.syncWithMoodle ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            tempRankCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isFromTempRanking ? 'badge-success' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isFromTempRanking ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },

        },
        mounted() {

        },
        computed:
            {
                token: function () {
                    return this.$store.getters.authToken;
                },
                userSettings() {
                    let grid = this.$refs.participantsGrid.kendoWidget();
                    return grid.getOptions();
                },
                filter() {
                    return {};
                },
                isEnVersion() {
                    return this.$store.getters.currentCulture === Culture.EN;
                },
                transportSettings() {
                    let urlSuffix = '';
                    if (this.lecturerId) {
                        urlSuffix = this.lecturerId;
                    }

                    return {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/lectors/listLecturerAllParticipations/`+urlSuffix,
                            dataType: 'json',
                            type: 'POST',
                            contentType: 'application/json',
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.parameterMap
                    }
                },
                gridBtns() {
                    let arr = [];

                    arr.push({
                        name: "viewEvent",
                        text: "",
                        tooltip: this.$t('buttons.viewEvent.btnText'),
                        class: 'btn btn-primary',
                        icon: "fas fa-eye",
                        show: true,
                        clickHandler: this.eventDetailsBtnClick
                    });

                    return arr;
                }
            }
    }
</script>


<style>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: 'DejaVu Sans', 'Arial', sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit,
    .k-grid-details,
    .k-grid-delete,
    .k-grid-pdf,
    .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>
